/** Deterministic integer hash of (seed, i, j) to [0, 1). Math.imul keeps it bit-identical on every JS engine. */
export function hash2(seed: number, i: number, j: number): number {
  let h = Math.imul(seed ^ 0x9e3779b9, 0x85ebca6b) ^ Math.imul(i, 0x27d4eb2d) ^ Math.imul(j, 0x165667b1);
  h = Math.imul(h ^ (h >>> 15), 0x2c1b3c6d);
  h = Math.imul(h ^ (h >>> 12), 0x297a2d39);
  h ^= h >>> 15;
  return (h >>> 0) / 4294967296;
}

const fade = (t: number): number => t * t * (3 - 2 * t);

/** Smooth value noise in [-1, 1] with a feature size of 1. */
export function valueNoise(seed: number, x: number, z: number): number {
  const i = Math.floor(x);
  const j = Math.floor(z);
  const tx = fade(x - i);
  const tz = fade(z - j);
  const a = hash2(seed, i, j);
  const b = hash2(seed, i + 1, j);
  const c = hash2(seed, i, j + 1);
  const d = hash2(seed, i + 1, j + 1);
  return 2 * ((a + (b - a) * tx) * (1 - tz) + (c + (d - c) * tx) * tz) - 1;
}
